import { createUseStyles } from 'react-jss';
import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';
import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  {
    root: {
      marginBottom: Spacings.s12,
      paddingTop: Spacings.s4,
      position: 'relative',
    },

    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      [BreakPointsMedia.MD]: {
        '&': {
          display: 'block',
        },
      },
      [BreakPointsMedia.SM]: {
        '&': {
          display: 'block',
        },
      },
      [BreakPointsMedia.XS]: {
        '&': {
          display: 'block',
        },
      },
      [BreakPointsMedia.XXS]: {
        '&': {
          display: 'block',
        },
      },
    },
  },
  {
    name: 'templates-category',
  },
);
export default useStyles;
